import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { stringify } from 'qs'
import { CmsProduct } from 'types/cms/collection-types'

/**
 * Get the faqs from the CMS
 *
 * @param {Language} locale
 * @returns {Promise<CmsFaqArticle[]>}
 */
const getProductsContent = async (locale: Language = Language.DUTCH): Promise<CmsProduct[]> => {
  try {
    const query = stringify({
      locale,
      status: 'published'
    })

    const { data } = await axios.get<CMSApiResponseBody<CmsProduct[]>>(`${process.env.CMS_API_URL}/products?${query}`)

    return data.data
  } catch (_) {
    return []
  }
}

export default getProductsContent
